// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WVHc","controls":"styles_controls__AIu_e","charLimit":"styles_charLimit__1zS-S","input":"styles_input__RCgsI","send":"styles_send__Mhifq"};